"use client"

import * as React from "react"
import { Button } from "@/components/ui/button"
import { DashboardSectionTitle } from "@/components/dashboard-section-heading"
import { cn } from "@/lib/utils"
import { QUALITY_PROGRAMS } from "@/lib/mock/evaluation-quality-dashboard"

export function QualityProgramComparison() {
  const [expanded, setExpanded] = React.useState(false)

  return (
    <section aria-labelledby="quality-programs-heading" className="flex flex-col gap-4">
      <div className="flex items-end justify-between gap-3">
        <DashboardSectionTitle as="h2" id="quality-programs-heading">
          Program performance
        </DashboardSectionTitle>
        <Button variant="ghost" size="sm" onClick={() => setExpanded(value => !value)}>
          {expanded ? "Show summary" : "Expand details"}
        </Button>
      </div>

      <div className="flex flex-col gap-3">
        {QUALITY_PROGRAMS.map(program => (
          <div key={program.id} className="flex flex-col gap-1.5">
            <div className="flex items-center justify-between gap-2 text-sm">
              <span className="font-medium text-foreground">{program.name}</span>
              <span className="tabular-nums text-muted-foreground">
                {program.overall.toFixed(1)}
                {program.trend === "up" ? " ↑" : program.trend === "down" ? " ↓" : ""}
              </span>
            </div>
            <div
              className="h-2 w-full overflow-hidden rounded-full bg-muted"
              role="progressbar"
              aria-valuenow={Math.round((program.overall / 5) * 100)}
              aria-valuemin={0}
              aria-valuemax={100}
              aria-label={`${program.name} overall experience`}
            >
              <div
                className={cn(
                  "h-full rounded-full",
                  program.trend === "down" ? "bg-chart-4" : "bg-brand",
                )}
                style={{ width: `${(program.overall / 5) * 100}%` }}
              />
            </div>
            {expanded ? (
              <p className="text-xs tabular-nums text-muted-foreground">
                Clinical {program.clinical.toFixed(1)} · Faculty {program.faculty.toFixed(1)} ·{" "}
                {program.response}% response
              </p>
            ) : null}
          </div>
        ))}
      </div>
    </section>
  )
}
